var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"home-header"},[_c('span',[_vm._v("Vdb Pro 数据大屏")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }